// extracted by css-extract-rspack-plugin
export default {"commentBody":"PendingCommentPreview-module__commentBody___5gAWen"};